module.exports = __webpack_public_path__ + "static/media/caretDown.9392e204.svg";